import React from 'react';
import ReactSelect from 'react-select';

const CustomSelect = ({
  value,
  onChange,
  options,
  controlWidth = 200,
  controlHeight = 'auto',
  menuWidth = 200,
  dropdownIndicatorSize,
  dropdownIndicatorPadding,
  clearIndicatorSize,
  clearIndicatorPadding,
  showIndicatorSeparator = true,
  className,
  ...props
}) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: controlWidth,
      height: controlHeight,
      minHeight: controlHeight,
      maxHeight: controlHeight,
      ...props.controlStyles,
    }),
    menu: (provided) => ({
      ...provided,
      width: menuWidth,
      ...props.menuStyles,
    }),
    menuList: (provided) => ({
      ...provided,
      width: menuWidth,
      ...props.menuListStyles,
    }),
    valueContainer: (provided) => ({
      ...provided,
      ...props.valueContainerStyles,
    }),
    dropdownIndicator: (provided) => {
      const out = { ...provided, ...props.dropdownIndicatorStyles };
      if (dropdownIndicatorPadding != null) {
        out.padding = dropdownIndicatorPadding;
      }
      if (dropdownIndicatorSize != null) {
        out['& svg'] = {
          width: dropdownIndicatorSize,
          height: dropdownIndicatorSize,
        };
      }
      return out;
    },
    clearIndicator: (provided) => {
      const out = { ...provided, ...props.clearIndicatorStyles };
      if (clearIndicatorPadding != null) out.padding = clearIndicatorPadding;
      if (clearIndicatorSize != null) out['& svg'] = {
        width: clearIndicatorSize,
        height: clearIndicatorSize,
      };
      return out;
    },
    indicatorSeparator: (provided) => ({
      ...provided,
      display: showIndicatorSeparator ? provided.display : 'none',
      ...props.indicatorSeparatorStyles,
    }),
  };

  return (
    <div className={className}>
      <ReactSelect
        value={value}
        onChange={onChange}
        options={options}
        styles={customStyles}
        menuShouldBlockScroll
        {...props}
      />
    </div>
  );
};

export default CustomSelect;
